// startup
// Load entry module and return exports
__webpack_require__("../node_modules/@babel/polyfill/lib/index.js");
__webpack_require__("./page-styles/repair.js");
__webpack_require__("./form.select.js");
// This entry module is referenced by other modules so it can't be inlined
__webpack_require__("./micromask.js");
__webpack_require__("./jquery.bez.js");
__webpack_require__("./template.main.js");
var __webpack_exports__ = __webpack_require__("./template.base.js");
